<article id="footerSection"
         class="w-full ci-bg--{{color}} px-3 md:px-0 pt-6 pb-3 flex flex-column gap-6 justify-content-center align-items-center">
  <section class="ci-main-padding w-full flex flex-column md:flex-row gap-6">
    <section class="w-full md:w-6 flex flex-column gap-4 md:gap-5 ci-txt--white">
      <section class="flex justify-content-center md:justify-content-start">
        <img src="https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fcocha-somos-innovacion-blanco.png?alt=media&token=32dd6e6f-d6a9-4e5b-bbf1-0ce2935ed5b2" alt="Somos Innovacion logo"
          class="w-20rem md:w-25rem h-auto mb-4">
      </section>

      <section class="w-full flex align-items-center gap-3">
        <i class="bi bi-building"></i>

        <section>
          Secretaria de Ciudad Digital y Gobierno Electrónico
        </section>
      </section>

      <section class="w-full flex align-items-center gap-3">
        <i class="bi bi-pin-map"></i>

        <section class="cursor-pointer"
                 (click)="openLink('https://www.google.com/maps?q=-17.394904090565696,-66.15996280921208')">
          Santivañez entre Junín y Hamiraya #233 
          <i class="bi bi-box-arrow-up-right ml-2"></i>
        </section>
      </section>

      <section class="w-full flex align-items-center gap-3">
        <i class="bi bi-headset"></i>

        <section class="cursor-pointer"
                 (click)="openLink('https://api.whatsapp.com/send?phone=59161561515&text=informaci%C3%B3n%20')">
          Call Center - +591 44258030
        </section>
      </section>
    </section>

    <section class="w-full md:w-6 flex flex-column align-items-center md:align-items-end justify-content-center">
      <p class="ci-txt--white pb-3">
        Síguenos en:
      </p>
      
      <app-rrss-links [type]="'default'" [cssClass]="'ci-txt--white md:text-6xl'">
      </app-rrss-links>
    </section>
  </section>

  <div class="flex flex-column gap-3 md:gap-2 ci-txt--white text-center pb-2">
    <small>
      © {{year}} Derechos Reservados - Departamento de Ciudad Inteligente
    </small>

    <small class="text-sm">
      <strong>
        Gobierno Autónomo Municipal de Cochabamba
      </strong>
    </small>
  </div>
</article>